import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseCodePolicy extends BasePolicy {
    /**
     *
     * @param user
     * @returns {*}
     */
    viewAny(user) {
        // Must match the backend CourseCodePolicy::viewAny, which requires
        // `view any course code` for the course-codes index.
        return user.hasPermissionTo('view any course code') || user.hasGroupPermissionTo('view any course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    create(user) {
        return user.hasPermissionTo('create a course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    update(user) {
        return user.hasPermissionTo('edit a course code');
    }

    /**
     *
     * @param {User} user
     * @returns {*}
     */
    delete(user) {
        return user.hasPermissionTo('delete a course code');
    }
}
